import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import Rate from '@/components/shared/Rate';
import { useGetRatingQuery, useSaveRatingMutation } from '@/services/lesson';

function Stars() {
  const { id } = useParams();
  const [currentRating, setCurrentRating] = useState(-1);
  const rating = useGetRatingQuery(id);
  const [save, { isLoading }] = useSaveRatingMutation();

  const handleSubmitRating = (rating: number) => {
    setCurrentRating(rating);
    save({ lessonId: id, rating });
  };

  useEffect(() => {
    setCurrentRating(-1);
    rating.refetch();
    //eslint-disable-next-line
  }, [id]);

  return (
    <Rate
      userRating={currentRating == -1 ? rating.data?.user_rating : currentRating}
      onChange={handleSubmitRating}
      isFetching={isLoading}
    />
  );
}

export default Stars;
